<template lang="pug">
  v-dialog(v-model="value" max-width="600px" persistent)
    v-card.rounded-card(data-cy="ein-decision-modal")
      v-card-title.pb-2
        v-layout(row justify-center)
          v-flex(xs12)
            h2.primary--text.text-xs-center.font-weight-thin.title-pad {{ titleText }}
      v-card-text.pt-2.pb-2
        v-layout(row)
          v-flex(xs12)
            p {{ p1Text }}
            p(v-html="p2Text")
            p(v-html="p3Text")
        v-layout.mt-1.mb-2(column)
          v-flex(xs12)
            v-layout(row justify-space-around wrap)
              v-flex.mt-1(xs12 sm5)
                v-layout(column align-center)
                  v-btn.primary.action-btn.ma-0(xs12 @click="goToEinRoute" small)
                    v-layout(column)
                      span I have a business with
                        br 
                        | a tax ID (EIN or BN)
              v-flex(xs12 sm5)
                v-layout.mt-1.xs12(column align-center)
                  v-btn.xs12.primary.action-btn.ma-0(@click="goToNoEinRoute" small)
                    v-layout(column)
                      span I do not have a
                        br 
                        | business tax ID*
        v-layout.mt-4(column align-center text-xs-center v-if="isIncompleteReg")
          v-flex.mt-3(xs12)
            a.skip(@click="onSkipRegistration") Skip for now - I'll register later
          v-flex.my-3(xs12)
            a(
              href="https://lonewolf.my.site.com/s/article/LD-FAQ-Texting-brand-registration-changes-June-2023-LionDesk"
              target="_blank"
            ) After August 31st, you will no longer be able to text in LionDesk without a valid registration
        v-layout.mt-4(column align-center v-else)
          v-flex.mt-3(xs12)
            v-btn.close-button(@click="onSkipRegistration") Close
          v-flex.my-3(xs12)
            a.text-xs-center(
              href="https://lonewolf.my.site.com/s/article/LD-FAQ-Texting-brand-registration-changes-June-2023-LionDesk"
              target="_blank"
            ) Learn more about texting in LionDesk
</template>

<script>
export default {
  name: 'EinDecisionModal',
  props: {
    openDialog: false,
    isIncompleteReg: false,
  },
  methods: {
    goToNoEinRoute() {
      this.$emit('show-registration-brand-modal');
    },
    goToEinRoute() {
      this.$emit('soft-close');
      this.$router.push('/a2p-lowstandardbrand-registration');
    },
    onSkipRegistration() {
      this.$emit('close');
      this.$emit('skip-registration');
    },
  },
  computed: {
    titleText() {
      return 'Get registered. Get Texting';
    },
    p1Text() {
      if (this.isIncompleteReg) {
        return 'Wireless carriers have additional requirements for business texting.';
      }
      return "To unlock LionDesk's powerful texting suite, we need to get your business registered and validated with The Campaign Registry. This validates your SMS traffic with wireless carriers and ensures your messages reach your contacts.";
    },
    p2Text() {
      if (this.isIncompleteReg) {
        return `To keep texting from LionDesk, all users need to get registered and validated with The Campaign Registry.`;
      }

      return `Registration is optional but you'll need to do it if you want to text in LionDesk.`;
    },
    p3Text() {
      if (this.isIncompleteReg) {
        return `Just follow our on-screen guide and complete it by <strong>August 15th</strong> to continue texting in LionDesk.`;
      }

      return ``;
    },
    value: {
      get() {
        return this.openDialog;
      },
      set() {
        this.$emit('close');
      },
    },
  },
};
</script>

<style scoped>
.action-btn {
  height: 60px;
  text-transform: none;
  width: 100%;
}
.rounded-card {
  border-radius: 10px;
}
.title-pad {
  padding-left: 40px;
  padding-right: 40px;
}
.v-card {
  padding-top: 5%;
  padding-left: 10px;
  padding-right: 10px;
}

.skip {
  font-weight: 500;
}

.close-button {
  color: var(--v-primary-base);
  background-color: transparent !important;
}
</style>
